import { showNotification } from './notifications';

const MOCK_MODE = import.meta.env.VITE_USE_MOCK_DATA || 'false';

export class MockHandler {
  static shouldUseMock(apiSuccess: boolean, data: any): boolean {
    if (MOCK_MODE === 'bypass') return true;
    if (MOCK_MODE === 'api' && (!apiSuccess || this.isEmpty(data))) return true;
    return false;
  }

  static isEmpty(data: any): boolean {
    if (!data) return true;
    if (Array.isArray(data) && data.length === 0) return true;
    if (typeof data === 'object' && Object.keys(data).length === 0) return true;
    return false;
  }

  static handleEmptyResponse(endpoint: string): void {
    if (MOCK_MODE === 'false') {
      showNotification('info', `No data available for ${endpoint}`);
    }
  }

  static getMockMode(): string {
    return MOCK_MODE;
  }
}